module.exports = __webpack_public_path__ + "media/images/stores5-267dbe997c579aaffc3a6e329f836c7b.jpg";